import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cursor_right_bottom.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-129f1c28")

_pushScopeId("data-v-129f1c28")
const _hoisted_1 = { class: "fridgesettingsquickbutton-top" }
const _hoisted_2 = { class: "fridgesettingsquickbutton-top-title" }
const _hoisted_3 = { class: "fridgesettingsquickbutton-top-title-text" }
const _hoisted_4 = { class: "fridgesettingsquickbutton-top-description" }
const _hoisted_5 = { class: "fridgesettingsquickbutton-top-description-text" }
const _hoisted_6 = { class: "fridgesettingsquickbutton-value" }
const _hoisted_7 = { class: "fridgesettingsquickbutton-value-name" }
const _hoisted_8 = { class: "fridgesettingsquickbutton-value-name-text" }
const _hoisted_9 = { class: "fridgesettingsquickbutton-value-time" }
const _hoisted_10 = { class: "fridgesettingsquickbutton-value-time-text" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "fridgesettingsquickbutton-value-arrow" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "fridgesettingsquickbutton-value-arrow-image",
    src: _imports_0
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "fridgesettingsquickbutton",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickQuickbutton(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.modeText), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.pushCountText), 1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.name), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.timeText), 1)
      ]),
      _hoisted_11
    ])
  ]))
})